import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { idpSSO } from '../services/api'

interface Props {
  children: ReactNode
  requireSuperadmin?: boolean
}

export default function ProtectedRoute({ children, requireSuperadmin }: Props) {
  const { isAuthenticated, user } = useAuth()

  if (!isAuthenticated) {
    window.location.href = idpSSO.getLoginUrl()
    return null
  }

  if (requireSuperadmin && !user?.is_superadmin) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
